import * as ko from "knockout";
import {global, lm} from "../../../appContext";
import {storeObservable} from "../../../util/sessionstore";
import detailsHtml from './details.html?raw';

export let template = detailsHtml;

export class viewModel {
    private readonly isReady: KnockoutObservable<boolean> = global.login.isLoggedIn;
    private readonly isTranslationsReady: KnockoutComputed<boolean> = ko.pureComputed((): boolean => {
        return !!lm.isReady();
    });
    private readonly pv = global.permissionValidator;
    private readonly toggle: KnockoutObservable<boolean> = storeObservable('layout.right.toggle');
    private readonly panelMode: KnockoutObservable<'profile' | 'chat'> = storeObservable('layout.right.mode');
    private readonly detailsSettings: KnockoutObservable<boolean> = storeObservable('details.settings.toggle');

    /** Stays true after first profile open so close/reopen does not remount the sidepanel. */
    private readonly profilePanelMounted: KnockoutObservable<boolean> = ko.observable(false);

    constructor() {
        const latchProfileMount = () => {
            if (this.toggle() && this.panelMode() === 'profile') {
                this.profilePanelMounted(true);
            }
        };
        this.toggle.subscribe(latchProfileMount);
        this.panelMode.subscribe(latchProfileMount);
        latchProfileMount();
    }

    private onBackdropClick() {
        this.toggle(false);
    }
}
